module.exports = __webpack_public_path__ + "static/media/carbon.7cdb4346.png";